import { FormattedMessage } from 'react-intl';
import { Grid } from '@material-ui/core';
import { WikusButton } from '@wikus-ui/components/core/button';

export type NotificationFilterType = 'all' | 'shipments' | 'orders';

export interface NotificationFilterProps {
  selectedFilter: NotificationFilterType;
  onChange: (filter: NotificationFilterType) => void;
}

export const NotificationFilter = ({ selectedFilter, onChange }: NotificationFilterProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item>
        <WikusButton
          color="primary"
          variant={selectedFilter === 'all' ? 'contained' : 'outlined'}
          onClick={() => onChange('all')}>
          <FormattedMessage id="notifications.filter.all" />
        </WikusButton>
      </Grid>
      <Grid item>
        <WikusButton
          color="primary"
          variant={selectedFilter === 'shipments' ? 'contained' : 'outlined'}
          onClick={() => onChange('shipments')}>
          <FormattedMessage id="notifications.filter.shipments" />
        </WikusButton>
      </Grid>
      <Grid item>
        <WikusButton
          color="primary"
          variant={selectedFilter === 'orders' ? 'contained' : 'outlined'}
          onClick={() => onChange('orders')}>
          <FormattedMessage id="notifications.filter.orders" />
        </WikusButton>
      </Grid>
    </Grid>
  );
};
